import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    '& .search': {
      paddingRight: theme.spacing(4.5),
    },
  },
  loader: {
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(1),
  },
}));
